import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styles from './profile.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faEdit, faHome, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

const baseURL = `${process.env.REACT_APP_API_URL}`

const Profile = () => {
    const [profileData, setProfileData] = useState(null);
    const navigate = useNavigate()
    const [error, setError] = useState('')

    useEffect(() => {
        const token = localStorage.getItem('accessToken')
        if (token) {
            axios.get(`${baseURL}/profiles/profile/`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            })
            .then((response) => {
                setProfileData(response.data);
            })
            .catch((error) => {
                console.error('Error fetching profile data:', error);
                setError('Error fetching profile data:', error)
            })
        } else {
            console.error('No access token found, redirecting to login');
            navigate('/login')
        }
        
    }, [navigate])


    if (!profileData) return (
            <div className={styles.loadingContent}>
              <FontAwesomeIcon icon={faSpinner} spin size="3x" className={styles.spinner} />
              <span className={styles.loadingText}>Loading...</span>
            </div>
          );

    const {
        user_type,
        first_name,
        last_name,
        bio,
        location,
        tribe,
        hobbies,
        rating,
        image,
        reviews,
        ...specificFields
    } = profileData;
    return (
        <div className={styles.profileContainer}>
            {error && <p className={styles.error}>{error}</p>}
            <div className={styles.profileHeader}>
                <img 
                    src={image ? `${baseURL}${image}` : '/default-profile.png'}
                    alt={first_name}
                    className={styles.profileImage}
                />
                <div>
                    <h1>{`${first_name} ${last_name}`}</h1>
                    <p className={styles.userType}>{user_type}</p>
                    <p className={styles.rating}>
                        <FontAwesomeIcon icon={faStar} /> {rating ? rating.toFixed(1) : "N/A"}
                    </p>
                </div>
                {user_type === 'HouseManager' ? (
                    <Link to={`/profile/house_manager/${profileData.id}`}
                    className={styles.searchProfile}>
                    View Your Search Profile
                    </Link>

                ) : user_type === 'Employer' ? (
                    <Link to={`/profile/employer/${profileData.id}`}
                    className={styles.searchProfile}>
                    View Your Search Profile
                    </Link>
                ) : (
                    <p>No specific profile link available.</p>
                )}
            </div>
            <div className={styles.aboutSection}>
                <h2>About</h2>
                <p><strong>About Me:</strong> {bio || "Not specified"}</p>
                <p>
                    <FontAwesomeIcon icon={faHome} style={{color: '#007bff'}}/> {location || "Not specified"}
                </p>
                <p>
                    <strong>Tribe:</strong> {tribe || 'Not specified'}
                </p>
                <p>
                    <strong>Hobbies:</strong> {hobbies || 'Not specified'}
                </p>
            </div>

            <div className={styles.detailsSection}>
                <h2>{user_type} Details</h2>
                <ul>
                    {Object.entries(specificFields).filter(([key]) => key !== 'id')
                    .map(([key, value]) =>(
                        <li key={key}>
                            <strong>{key.replace(/_/g, " ")}</strong> {value || 'Not specified'}
                        </li>
                    ))}
                </ul>
            </div>

            <div className={styles.reviewsSection}>
                <h2>Reviews</h2>
                {reviews.length ? (
                    reviews.map((review, index) => (
                        <div key={index} className={styles.review}>
                            <p>
                                <strong>{review.reviewer__username}</strong>{" "}
                                <span className={styles.reviewData}>
                                    ({new Date(review.created_at).toLocaleDateString()})
                                </span>
                            </p>
                            <p>
                                <FontAwesomeIcon icon={faStar} className={styles.rating}/> {review.rating.toFixed(1)}
                            </p>
                            <p>{review.comment}</p>
                        </div>
                    ))
                ) : (
                    <p>No Reviews yet.</p>
                )}
            </div>

            <div className={styles.actions}>
                <button className={styles.editButton}>
                    <FontAwesomeIcon icon={faEdit} /> Edit Profile
                </button>
            </div>
        </div>
    );
};

export default Profile;